import React, { useEffect, useMemo } from "react";
import ShareComponent from "./ShareComponent";
import HeartIcon from "../assets/svg/HeartIcon";

function FooterQRCode({
  isGcPage,
  isPressedPage = false,
  isMobile,
  title = "Your Home In The Metaverse",
  subTitle = "Beta on Harmony",
  classSpec,
  display = "flex",
}) {
  if (isPressedPage) {
    return (
      <footer
        className={`${isMobile && isGcPage ? "is-mobile" : ""} ${classSpec}`}
        style={{ display: display }}
      >
        <div className="harmony" style={{ width: "100%", textAlign: "center" }}>
          <div className="font-n23 msr-bold">{title}</div>
          <ShareComponent
            style={{ justifyContent: "center", margin: "1rem 0" }}
          />
        </div>
      </footer>
    );
  }
  return (
    <footer
      className={`${isMobile && isGcPage ? "is-mobile" : ""} ${classSpec}`}
    >
      {isGcPage ? (
        <div className="harmony">
          <div className="font-n23 msr-bold">{title}</div>
          <div className="font-n16 msr-medium text-harmony">{subTitle}</div>
        </div>
      ) : (
        <>
          <ShareComponent />
          <div className="made-by font-n10">
            MADE WITH <HeartIcon /> BY TIMELESS WALLET
          </div>
        </>
      )}
    </footer>
  );
}

export default FooterQRCode;
